<template>
  <div v-if="isVisible" class="about-overlay" @click.self="close">
    <div class="about-dialog">
      <div class="about-header">
        <span class="about-header-title">{{ t('このサイトについて') }}</span>
        <div class="close-btn" @click="close">
          <span>&times;</span>
        </div>
      </div>
      <div class="about-body">
        <h2 class="site-title">
          <img src="/img/logo_pc_nm.png" alt="GTCHAX ONLINE">
        </h2>
        <img src="/img/about/shop_image.png" class="main-image" />
        <p class="catch-copy">{{ t('様々なアイテムをガチャでゲット！') }}</p>
        <div class="steps">
          <div class="step">
            <div class="step-icon-wrapper">
              <img src="/img/about/account.png" class="step-icon" />
            </div>
            <div class="step-label">
              <span class="step-number">1</span>
              <span class="step-text">{{ t('まずは会員登録！') }}</span>
            </div>
          </div>
          <div class="step">
            <div class="step-icon-wrapper">
              <img src="/img/about/coin.png" class="step-icon" />
            </div>
            <div class="step-label">
              <span class="step-number">2</span>
              <span class="step-text">{{ t('コインを購入！') }}</span>
            </div>
          </div>
          <div class="step">
            <div class="step-icon-wrapper">
              <img src="/img/about/capsule.png" class="step-icon" />
            </div>
            <div class="step-label">
              <span class="step-number">3</span>
              <span class="step-text">{{ t('ガチャを回す！') }}</span>
            </div>
          </div>
          <div class="step">
            <div class="step-icon-wrapper">
              <img src="/img/about/receive.png" class="step-icon" />
            </div>
            <div class="step-label">
              <span class="step-number">4</span>
              <span class="step-text">{{ t('受け取り！') }}</span>
            </div>
          </div>
        </div>
        <label v-if="!alreadyHidden" class="no-show-again">
          <input type="checkbox" v-model="noShowAgain" />
          {{ t('次回以降表示しない') }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  mixins: [t],

  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      noShowAgain: false,
      alreadyHidden: document.cookie.split('; ').some((c) => c === 'hideAboutSiteDialog=1'),
    };
  },

  methods: {
    close() {
      if (this.noShowAgain) {
        document.cookie = 'hideAboutSiteDialog=1; path=/; max-age=31536000';
      }
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.about-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.about-dialog {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  padding: 10px 0;
}

.about-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 16px 0px 16px;
  position: relative;

  .about-header-title {
    font-size: 14px;
    color: #111;
    font-weight: bold;
  }

  .close-btn {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #12368d;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 20px;
  }
}

.about-body {
  padding: 15px 20px 20px 20px ;
  text-align: center;

  .site-title {
    font-size: 24px;
    font-weight: bold;
    margin: 0 0 16px;
    img {
      width: 80%;
      margin-top: -20px;
    }
  }

  .main-image {
    width: 60%;
    max-width: 240px;
  }

  .catch-copy {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  .steps {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 24px;

    .step {
      display: flex;
      flex-direction: column;
      align-items: center;

      .step-icon-wrapper {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background: radial-gradient(circle at center, #efe6a8 0%, #f3eab3 50%, #ffffff 70%, #ffffff 100%);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .step-icon {
        width: 110px;
        object-fit: contain;
      }

      .step-label {
        display: flex;
        align-items: baseline;
        gap: 4px;
        margin-top: -40px;

        .step-number {
          font-size: 24px;
          font-weight: bold;
          color: #12368d;
        }

        .step-text {
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }

  .no-show-again {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 14px;
    color: #666;
    cursor: pointer;

    input[type="checkbox"] {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
